import type { Config } from '@bugsnag/js'
import { isCIEnv, isProductionBuild } from '@cdc-internal/fe-toolbox/utils/env'

import { APP_VERSION, currentAppEnv, isProductionLikeAppEnv } from '@/configs/env'

const BUGSNAG_API_KEY = process.env.NEXT_PUBLIC_BUGSNAG_API_KEY

export const shouldInitializeBugsnag = () =>
  Boolean(isProductionLikeAppEnv && BUGSNAG_API_KEY && isProductionBuild && !isCIEnv)

export const sharedBugsnagConfig: Pick<Config, 'appVersion' | 'releaseStage' | 'apiKey'> = {
  appVersion: APP_VERSION,
  releaseStage: currentAppEnv,
  apiKey: BUGSNAG_API_KEY,
}
